<template>
  <svg
    ref="sparkline"
    class="mx-auto stroke-current w-24 h-6"
    :class="difference > 0 ? 'text-red-400' : 'text-green-400'"
    :stroke-width="stroke"
    stroke-linecap="round"
    stroke-linejoin="round"
  >
    <path :d="shape" :stroke="stroke" fill="none" />
  </svg>
</template>

<script>
export default {
  props: ['data'],
  data() {
    return {
      stroke: 2,
      width: 96,
      height: 24
    }
  },
  computed: {
    difference() {
      return this.data[this.data.length - 1] - this.data[0] || 0
    },
    shape() {
      if (!this.data[0] || this.data.every(val => val === this.data[0]))
        return 'M -1 -1 L -1 -1 L -1 -1'

      const inset = this.stroke / 2
      const width = this.width - inset * 2
      const height = this.height - inset * 2

      const totalPoints = this.data.length - 1
      const lowestPoint = Math.min.apply(null, this.data)
      const highestPoint = Math.max.apply(null, this.data)

      let coordinates = this.data.map((item, n) => {
        return {
          x: inset + (width / totalPoints) * n,
          // normalize function: (x – min) / (max – min)
          y:
            inset +
            height -
            ((item - lowestPoint) / (highestPoint - lowestPoint)) * height
        }
      })

      return `M ${coordinates[0].x} ${coordinates[0].y} ${coordinates
        .map(point => `L ${point.x} ${point.y} `)
        .join('')}`
    }
  }
}
</script>
